<template>
    <div class="tab-bar">
        <router-link :class="{'router-link-active':isReportActive(tab)}" v-for="(tab, title) in tabs" :to="title" :key="tab"><span>{{ tab }}</span></router-link>
    </div>
</template>


<script type="text/javascript">
export default {
    props: {
      tabs: {
        default: () => ({})
      }
    },
    methods: {
        isReportActive(tab){
          let url_array = this.$route.path.split('/');
          let reportInUrl = false;
          for (var i = 0; i < url_array.length; i++) {
            if (url_array[i].trim(' ') === 'reports'){
                reportInUrl = true;
                break;
            }
          }
          return (reportInUrl === true && tab === 'Reports');
        }
    }
};
</script>


<style lang="scss">
@import "../css/constants";
.tab-bar {
    background-color: white;
    margin-bottom: $p24;
    margin-left: -$p24;
    margin-right: -$p24;
    padding-left: $p24;
    padding-right: $p24;
    a > span {
        padding: $p12 $p14;
        display: inline-block;
        font-size: $p14;
        font-family: "Hind Medium";
        color: $gray7;
        border-top: 2px solid white;
        transition: all 0.3s ease;

        &:hover {
            background-color: $gray1;
            border-top: 2px solid $gray1;
        }
    }

    a.router-link-active > span {
        background-color: $gray1;
        color: $gkred;
        border-top: 2px solid $gkred;
        border-radius: 2px;
    }
}
.active-top {
  border-top: 2px solid #243c98;
}
.is-active {
    background-color: #F8F8F8;
    color: #243c98;
    border-top: 2px solid #243c98;
    border-radius: 2px;
}

</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue